//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeaderForm from "@/components/50.wisdomMini/HeaderForm/index.vue";
import card from "@/components/50.wisdomMini/Card/index.vue";
import FooterBox from "@/components/50.wisdomMini/FooterBox/index.vue";

export default {
  components: {
    HeaderForm,
    card,
    FooterBox
  },
  data() {
    return {
      isIpx: false,
      DataList: {},
      currentMonthData: [
        {
          name: "新增会员",
          count: "",
          increase: "",
          flags: true
        },
        {
          name: "本月新增",
          count: "",
          increase: "",
          flags: true
        },
        {
          name: "累计新增",
          count: "",
          increase: "",
          flags: true
        },
        {
          name: "本月任务数",
          count: 0,
          increase: 0,
          flags: true
        },
        {
          name: "本月分享数",
          count: 0,
          increase: 0,
          flags: true
        },
        {
          name: "本月阅读数",
          count: 0,
          increase: 0,
          flags: true
        }
      ],
      cards: [
        {
          title: "会员管理",
          list: [
            {
              icon: "mendianhuiyuan",
              iconDesc: "门店会员",
              source: "customer",
              routeName:
                "/SmartGms/Member/Index"
            },
            {
              icon: "huiyuanbiaoqian",
              iconDesc: "分组标签",
              source: "customer",
              routeName: "/SmartGms/MemberLabel/Index"
            },
            {
              icon: "huiyuanrenwu",
              iconDesc: "会员任务",
              source: "customer",
              routeName: "/SmartGms/PrizeStockOutGuideCouponOrder/Index"
            },
            {
              icon: "woderenwu",
              iconDesc: "我的任务",
              source: "customer",
              routeName: "/SmartGms/GuideCouponStockData/Index"
            }
          ]
        },
        {
          title: "会员服务",
          list: [
            {
              icon: "zhishiku",
              iconDesc: "知识库",
              source: "customer",
              routeName: "/SmartGms/Article/Index"
            },
            {
              icon: "huashu",
              iconDesc: "话术",
              source: "customer",
              routeName: "/SmartGms/SalesPatter/Index"
            },
            {
              icon: "tuijilu",
              iconDesc: "推送记录",
              source: "customer",
              routeName: "/SmartGms/ArticleShareOrder/DetailIndex"
            }
          ]
        },
        {
          title: "迷你CRM",
          list: [
            {
              icon: "funeng@2x",
              iconDesc: "赋能工具",
              routeName: "/SmartGms/MemberFace/Index",
              source: "user"
            }
          ]
        }
      ]
    };
  },
  computed: {
    isLogin: function() {
      return this.$appBox.isLogin();
    }
  },
  mounted() {
   
  },
  onShow() {
    this.GetCustomerPanelData();
  },
  onLoad() {
    var that = this;
    this.GetCustomerPanelData();
    
  },

  methods: {
    alertLogin() {
      this.$msg.alert("您还未登录，请登录系统，绑定身份后使用.");
      return;
    },

    loadCustomerPanelData() {
      this.isLogin = this.$appBox.isLogin();
      if (this.isLogin) {
        //新增会员
        var currentMonthData = this.currentMonthData;
        currentMonthData[0].count = this.DataList.curDayMemberNum;
        currentMonthData[0].increase = 0;

        //本月新增
        currentMonthData[1].count = this.DataList.curMonthMemberNum;
        currentMonthData[1].increase = 0;

        //累计新增
        currentMonthData[2].count = this.DataList.totalCount;
        currentMonthData[2].increase = 0;

        //本月任务数
        currentMonthData[3].count = 4;
        currentMonthData[3].increase = 1;

        //本月分享数
        currentMonthData[4].count = 211;
        currentMonthData[4].increase = 59;

        //本月阅读数
        currentMonthData[5].count = 69;
        currentMonthData[5].increase = 12;
        this.currentMonthData = currentMonthData;
      }
    },
    GetCustomerPanelData() {
     
    }
  }
};
